// extracted by mini-css-extract-plugin
export default {"dialog":"dialog--Py3O1"};